import { gql } from '@apollo/client';
import {
	getCartQueryString,
	getCreditCardDetailsQueryString,
	getPersonalDataQueryString,
	getSepaMandatQueryString,
	getShortTextLabelsQueryString,
} from './utils';

export const getEditPaymentCollection = gql`
	query getVignettesOrderManagementCollection($lang: String) {
		vignettesOrderManagementCollection(locale: $lang, limit: 1) {
			items {
                paymentNotSuccessfulText
                ${getPersonalDataQueryString()}
                ${getCreditCardDetailsQueryString()}
                ${getSepaMandatQueryString()}
                ${getCartQueryString()}
                hintMessages: hintMessagesCollection(locale: $lang, limit: 5) {
					items {
                        id
                        tip(locale: $lang)
                        linkText(locale: $lang)
                        message(locale: $lang) {
                        json
                        }
                    }
				}
				${getShortTextLabelsQueryString([
					'untilRevoked',
					'backToOverview',
					'updateNow',
					'updatePaymentMethod',
					'updateBankDetails',
					'pendingAmount',
				])}
			}
		}
	}
`;
